import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import {
  EmptyState,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../components/empty-state/index';
import { useLocale } from '../../../../hooks/index';

type WorkspaceBrowserErrorProps = {
  onRetry: () => void;
};

// A folder whose first page failed: said plainly, with a way to try again — never the empty state,
// which would invite an upload into a folder that may not be there.
export const WorkspaceBrowserError: FC<WorkspaceBrowserErrorProps> = ({ onRetry }) => {
  const { messagesLocale } = useLocale();

  return (
    <EmptyState
      actions={
        <Button className="h-9 w-fit px-4 py-2" onClick={onRetry}>
          <AppFormattedMessage id="TRY_AGAIN" />
        </Button>
      }
      colorScheme={EmptyStateVariant.ORANGE}
      description={messagesLocale['FOLDER_CONTENTS_ERROR_HINT']}
      imageVariant={EmptyStateImageVariant.FLASHLIGHT}
      text={messagesLocale['FOLDER_CONTENTS_ERROR_TITLE']}
    />
  );
};
